<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col>
        <v-card>
          <v-toolbar class="light-blue darken-4 light-blue--text text--lighten-5">
            <v-toolbar-title>Настройки уведомлений</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col class="pb-0">
                Подключить <span />
                <a
                  :href="this.telegramUrl"
                  target="_blank"
                > телеграм-бот</a> уведомлений
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      @click="onClipboard"
                      v-on="on"
                    >
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </template>
                  <span>Скопировать ссылку в буффер обмена</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row v-if="isRegistered">
              <v-col class="pt-0">
                Вы уже зарегистрированы в боте
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text>
            <v-row>
              <v-col>
                Подключить уведомление:
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-checkbox
                  v-if="$store.state.access[35][1]"
                  v-model="userActions"
                  :label="reminderEvent()[1].text"
                  :value="reminderEvent()[1].value.toString()"
                  hide-details
                  @change="onChange"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-checkbox
                  v-if="$store.state.access[35][2]"
                  v-model="userActions"
                  :label="reminderEvent()[2].text"
                  :value="reminderEvent()[2].value.toString()"
                  hide-details
                  @change="onChange"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                class="py-0"
                cols="4"
              >
                <v-checkbox
                  v-if="$store.state.access[35][3]"
                  v-model="userActions"
                  :label="reminderEvent()[3].text"
                  :value="reminderEvent()[3].value.toString()"
                  hide-details
                  @change="onChange"
                />
              </v-col>
              <v-col
                class="pb-0"
                cols="4"
                offset="1"
                sm="2"
              >
                <v-select
                  v-if="$store.state.access[35][3]"
                  v-model="action3"
                  :items="intervals"
                  dense
                  hide-details
                  label="минут"
                  outlined
                  @change="onChangeInterval($event, 3)"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                class="py-0"
              >
                <v-checkbox
                  v-if="$store.state.access[35][4]"
                  v-model="userActions"
                  :label="reminderEvent()[4].text"
                  :value="reminderEvent()[4].value.toString()"
                  class="py-0"
                  hide-details
                  @change="onChange"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col class="my-0 py-0">
                <v-checkbox
                  v-if="$store.state.access[35][5]"
                  v-model="userActions"
                  :label="reminderEvent()[5].text"
                  :value="reminderEvent()[5].value.toString()"
                  hide-details
                  @change="onChange"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-checkbox
                  v-if="$store.state.access[35][6]"
                  v-model="userActions"
                  :label="reminderEvent()[6].text"
                  :value="reminderEvent()[6].value.toString()"
                  hide-details
                  @change="onChange"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-checkbox
                  v-if="$store.state.access[35][7]"
                  v-model="userActions"
                  :label="reminderEvent()[7].text"
                  :value="reminderEvent()[7].value.toString()"
                  hide-details
                  @change="onChange"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-checkbox
                  v-if="$store.state.access[35][8]"
                  v-model="userActions"
                  :label="reminderEvent()[8].text"
                  :value="reminderEvent()[8].value.toString()"
                  hide-details
                  @change="onChange"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-checkbox
                  v-if="$store.state.access[35][9]"
                  v-model="userActions"
                  :label="reminderEvent()[9].text"
                  :value="reminderEvent()[9].value.toString()"
                  hide-details
                  @change="onChange"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-checkbox
                  v-if="$store.state.access[35][10]"
                  v-model="userActions"
                  :label="reminderEvent()[10].text"
                  :value="reminderEvent()[10].value.toString()"
                  hide-details
                  @change="onChange"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-checkbox
                  v-if="$store.state.access[35][11]"
                  v-model="userActions"
                  :label="reminderEvent()[11].text"
                  :value="reminderEvent()[11].value.toString()"
                  hide-details
                  @change="onChange"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="d-flex justify-sm-space-around justify-center flex-wrap">
            <v-btn
              :disabled="disableButton"
              color="primary"
              @click="onSave"
            >
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { UserAction } from "@/views/reminder/models/action.model"
import { ActionService } from "@/views/reminder/shared/services/action-service"
import { EncodeService } from "@/views/loyalty/shared/services/encode-service"
import { BotService } from "@/views/reminder/shared/services/bot-service"
import { ReminderEvent } from "@/views/reminder/models/reminder.model"

export default {
  data: () => ({
    action3: 0,
    actionService: null,
    botService: null,
    clientId: null,
    clientNumber: null,
    disableButton: true,
    encodeService: null,
    intervals: [10, 15, 20, 25, 30, 35, 40, 45, 55],
    isRegistered: false,
    selected: ['0'],
    telegramUrl: "",
    userAllActions: [],
    userActions: [],
    userAction: null,
    userId: null,
    userIntervals: [],
    userNumber: null,
  }),
  beforeMount () {
    this.actionService = new ActionService()
    this.botService = new BotService()
    this.encodeService = new EncodeService(`${process.env.VUE_APP_NOTIF_URL}api/encode/`)
    this.userAction = new UserAction()
  },
  async mounted () {
    console.log('this.$store.state.client', this.$store.state.client)
    // console.log('this.$store.state.client.number', this.$store.state.client.number)
    console.log('this.$store.state.user.id', this.$store.state.user.id)
    console.log('this.$store.state.user.number', this.$store.state.user.number)
    if (this.$store.state.client !== null) {
      this.clientId = this.$store.state.client.id
      this.clientNumber = this.$store.state.client.number
    } else {
      this.clientId = "0"
      this.clientNumber = "0"
    }
    this.userId = this.$store.state.user.id
    if (this.$store.state.user.number === undefined) {
      this.userNumber = this.$store.state.user.number
    } else {
      this.userNumber = 0
    }
    this.userAllActions = await this.actionService.getAll(this.clientId, this.userId)
    this.userActions = this.userAllActions.map(m => m.action)
    this.userIntervals = this.userAllActions.map(m => m.interval)
    this.telegramUrl = await this.encodeService.encodeCustomerId(this.userId)
    console.log('userActions', this.userActions)
    this.action3 = this.userAllActions.find(f => f.action == 3) ? this.userAllActions.find(f => f.action == 3).interval : 10
    console.log('action3', this.action3)
    this.isRegistered = await this.botService.check(this.userId)
    console.log('isRegistered', this.isRegistered)
  },
  methods: {
    onClipboard () {
      navigator.clipboard.writeText(this.telegramUrl)
    },
    onChange () {
      this.disableButton = false
    },
    onChangeInterval (interval, index) {
      console.log('interval', interval)
      console.log('index', index)
      this.userAllActions = this.userAllActions.map(m => {
        if (m.action == index) {
          m.interval = interval
        }
        return m
      })
      console.log('this.userAllActions', this.userAllActions)
      this.disableButton = false
    },
    async onSave () {
      console.log('userActions', this.userActions)
      const toAdd = this.userActions.filter(f => !this.userAllActions.some(m => m.action == f))
      console.log('toAdd', toAdd)
      const toRemove = this.userAllActions.filter(f => !this.userActions.some(s => s == f.action))
      console.log('toRemove', toRemove)
      toAdd.forEach(f => {
        console.log('f', f)
        this.userAllActions.push({ action: f, interval: this.action3 })
      })
      this.userAllActions = this.userAllActions.filter(f => !toRemove.some(s => s.action == f.action))
      await this.actionService.save(this.clientId, this.clientNumber, this.userId, this.userNumber, this.userAllActions)
      this.disableButton = true
    },
    reminderEvent () {
      return ReminderEvent
    },
  }
}
</script>
<style scoped>

</style>
